function iOS(): boolean {
    const ua = window.navigator.userAgent.toLowerCase();
    return (
        ua.indexOf("iphone") > -1 ||
        ua.indexOf("ipad") > -1 ||
        ua.indexOf("ipod") > -1 ||
        (ua.indexOf("macintosh") > -1 && "ontouchend" in document)
    );
}

function android(): boolean {
    return /Android/.test(navigator.userAgent) || /Android/.test(navigator.platform);
}

function iPadOS(): boolean {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf("ipad") > -1 || (ua.indexOf("macintosh") > -1 && "ontouchend" in document);
}

function isPC(): boolean {
    return (
        (/Macintosh/.test(navigator.userAgent) && !("ontouchend" in document)) ||
        /Windows/.test(navigator.userAgent) ||
        /Linux_x86_64/.test(navigator.userAgent) ||
        /Linux_i686/.test(navigator.userAgent) ||
        /Linux i686/.test(navigator.userAgent) ||
        /Linux x86_64/.test(navigator.userAgent)
    );
    // /MacIntel/.test(navigator.platform) Apple change iPadOS 13 to use MacIntel platform
}

// Every Android mobile browsers contains Chrome and Gecko strings
function isAndroidChrome(): boolean {
    return (
        /Chrome/.test(navigator.userAgent) &&
        /EdgA/.test(navigator.userAgent) === false &&
        /Firefox/.test(navigator.userAgent) === false
    );
}

// Every iOS mobile browsers contains Safari string
function isIOSSafari(): boolean {
    return (
        /Safari/.test(navigator.userAgent) &&
        iOS() &&
        /EdgA/.test(navigator.userAgent) === false &&
        /EdgiOS/.test(navigator.userAgent) === false &&
        /CriOS/.test(navigator.userAgent) === false &&
        /FxiOS/.test(navigator.userAgent) === false
    );
}

function isAppMode(): boolean {
    // for Android Chrome
    if (window.matchMedia("(display-mode: standalone)").matches) {
        return true;
    }
    // for iOS Safari
    // if (window.navigator.standalone === true) {
    //     return true;
    // }

    return false;
}

function orientation(): string {
    return window.orientation === 90 || window.orientation === -90 ? "landscape" : "portraits";
}
export default {
    iOS,
    iPadOS,
    isPC,
    android,
    isAppMode,
    isIOSSafari,
    isAndroidChrome,
    orientation,
};
